import I18n from '../../languages/I18n';
import { server_img_url } from '../../config/constants';

function getFlagImage(color) {
  switch (color) {
    case 0: return require('../../assets/flags/none_fich.png');
    case 1: return require('../../assets/flags/green_fich.png');
    case 2: return require('../../assets/flags/orange_fich.png');
    case 3: return require('../../assets/flags/red_fich.png');
    case 4: return require('../../assets/flags/violet_fich.png');
    case 5: return require('../../assets/flags/white_fich.png');
    case 6: return require('../../assets/flags/vigie_fich.png');
    default: return require('../../assets/flags/none_fich.png');
  }
}

function getOstreopsisImage(level) {
  switch (level) {
    case 1: return require('../../assets/risks/ostreopsis1.png');
    case 2: return require('../../assets/risks/ostreopsis3.png');
    case 3: return require('../../assets/risks/ostreopsis3.png');
    case 4: return require('../../assets/risks/ostreopsis4.png');
    default: return require('../../assets/risks/ostreopsis1.png');
  }
}

function formatDate(isoString) {
  if (!isoString) return null;
  const d = new Date(isoString);
  const locale = I18n.locale === 'eu' ? 'es' : I18n.locale;
  const time = d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
  const isToday = new Date().toDateString() === d.toDateString();
  const sep = I18n.t('beach_details.updated_at_time');
  if (isToday) {
    return `${I18n.t('beach_details.updated_today')}${sep ? ' ' + sep : ''} ${time}`;
  }
  const date = d.toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: 'numeric' });
  return `${I18n.t('beach_details.updated_on')} ${date}${sep ? ' ' + sep : ''} ${time}`;
}

const BeachDetailsHeader = props => {
  const isGoodQuality = props.quality === 1 || props.quality === 3;
  const isBadQuality = props.quality === 2 || props.quality === 4 || props.quality === 5;
  const hasOstreopsis = props.ostreopsis != null && props.ostreopsis !== 0;

  const qualityIcon = isGoodQuality
    ? require('../../assets/qualities/goodquality.png')
    : isBadQuality
      ? require('../../assets/qualities/badquality.png')
      : require('../../assets/qualities/noquality.png');

  let qualityLabel = I18n.t('flag_explanations.no_quality');
  if (isGoodQuality) {
    qualityLabel = I18n.t('flag_explanations.conform_quality');
  } else if (isBadQuality) {
    qualityLabel = (props.quality_explanation && props.quality_explanation !== null)
      ? I18n.t('quality_explanations.explanation_' + props.quality_explanation)
      : I18n.t('flag_explanations.not_conform_quality');
  }

  const qualityCardStyle = isGoodQuality ? styles.cardGood
    : isBadQuality ? styles.cardBad
    : styles.cardNeutral;

  const ostreopsisLevel = props.ostreopsis;
  const ostreopsisCardStyle = ostreopsisLevel === 4 ? styles.cardOstreopsis4
    : (ostreopsisLevel === 2 || ostreopsisLevel === 3) ? styles.cardOstreopsis23
    : styles.cardOstreopsis1;

  const qualityTimestamp = formatDate(props.quality_updated_at);
  const ostreopsisTimestamp = formatDate(props.ostreopsis_updated_at);

  return (
    <div style={{ width: '100%', position: 'relative' }}>

      {/* City name over photo */}
      <div style={{
        position: 'absolute',
        top: 10,
        left: 0,
        width: '100%',
        color: '#FFF',
        fontSize: 21,
        paddingTop: 15,
        textAlign: 'center',
        textShadow: '2px 2px 2px rgba(0,0,0,0.5)',
      }}>
        {props.city}
      </div>

      {/* Beach photo */}
      <img
        src={server_img_url + 'beaches/' + props.url_img}
        style={{ height: 300, width: '100%', objectFit: 'cover' }}
        alt="Plage"
      />

      {/* Flag image centered, overlapping bottom of photo */}
      <div style={{
        position: 'absolute',
        top: 220,
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
      }}>
        <img alt="flag" src={getFlagImage(props.color)} style={{ width: 160, height: 160 }} />
      </div>

      {/* Flag explanation */}
      <div style={{
        fontSize: 14,
        fontWeight: '700',
        color: '#333337',
        textAlign: 'center',
        marginTop: 64,
        marginBottom: 16,
        paddingHorizontal: 20,
        padding: '0 20px',
      }}>
        {I18n.t('flag_explanations.explanation_' + props.explanation)}
      </div>

      {/* Beach name */}
      <div style={{ textAlign: 'center', fontSize: 22, fontWeight: '600', marginBottom: 16, color: '#333337' }}>
        {props.name}
      </div>

      {/* Quality + Ostreopsis cards */}
      <div style={{ padding: '0 20px 16px', display: 'flex', flexDirection: 'column', gap: 8 }}>

        {/* Quality card */}
        <div style={{ ...styles.card, ...qualityCardStyle }}>
          <div style={styles.cardRow}>
            <img alt="quality" src={qualityIcon} style={styles.cardIcon} />
            <span style={styles.cardLabel}>{qualityLabel}</span>
          </div>
          {(isGoodQuality || isBadQuality) && qualityTimestamp && (
            <div style={styles.timestamp}>{qualityTimestamp}</div>
          )}
        </div>

        {/* Ostreopsis card — only if active */}
        {hasOstreopsis && (
          <div style={{ ...styles.card, ...ostreopsisCardStyle }}>
            <div style={styles.cardRow}>
              <img alt="ostreopsis" src={getOstreopsisImage(ostreopsisLevel)} style={styles.cardIcon} />
              <span style={styles.cardLabel}>
                {I18n.t('ostreopsis_explanations.explanation_' + ostreopsisLevel)}
              </span>
            </div>
            {ostreopsisTimestamp && (
              <div style={styles.timestamp}>{ostreopsisTimestamp}</div>
            )}
          </div>
        )}

      </div>
    </div>
  );
};

const styles = {
  card: {
    borderRadius: 10,
    padding: '10px 14px',
    border: '1px solid',
  },
  cardGood: {
    backgroundColor: '#EEF8FA',
    borderColor: '#6CC6D7',
  },
  cardBad: {
    backgroundColor: '#F4EEF4',
    borderColor: '#753376',
  },
  cardNeutral: {
    backgroundColor: '#F5F5F5',
    borderColor: '#BBBBBB',
  },
  cardOstreopsis1: {
    backgroundColor: '#EDF8F8',
    borderColor: '#8AD3D3',
  },
  cardOstreopsis23: {
    backgroundColor: '#FCF6EF',
    borderColor: '#EDD4BA',
  },
  cardOstreopsis4: {
    backgroundColor: '#FDEEF0',
    borderColor: '#F4AFB6',
  },
  cardRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardIcon: {
    width: 20,
    height: 20,
    marginRight: 10,
    objectFit: 'contain',
  },
  cardLabel: {
    fontSize: 13,
    fontWeight: '600',
    color: '#333337',
    textAlign: 'center',
  },
  timestamp: {
    fontSize: 11,
    color: '#888',
    marginTop: 4,
    textAlign: 'center',
  },
};

export default BeachDetailsHeader;
